// extracted by mini-css-extract-plugin
export var addToCartButton = "_u7-b";
export var arrowButtonContainer = "_u7-9";
export var arrowButtonIcon = "_u7-a";
export var carouselArrowButton = "_u7-6";
export var carouselElementContainer = "_u7-1";
export var left = "_u7-7";
export var productDisplayCarouselContainer = "_u7-0";
export var productTileContainer = "_u7-2";
export var productTileImage = "_u7-4";
export var productTileImageContainer = "_u7-3";
export var productTileTitle = "_u7-5";
export var right = "_u7-8";
export var sliderOverflow = "_u7-c";